module.exports = __webpack_public_path__ + "img/jieshao2.09333d53.png";